import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_OrderConfiguration } from '@app/org-shared';
export const dispatch_onOrderConfigurationChanged = new ThunderDispatcherV3('__onOrderConfigurationUpdated');
export class ModuleFE_OrderConfiguration_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_OrderConfiguration, dispatch_onOrderConfigurationChanged);
        this._v1 = {};
    }
}
export const ModuleFE_OrderConfiguration = new ModuleFE_OrderConfiguration_Class();
//# sourceMappingURL=ModuleFE_OrderConfiguration.js.map